<template>
  <div>
    <div v-if="isEditor">
      <Row :gutter="4">
        <h5>{{ label }}</h5>
        <Col span="24">
        <FormItem>
          <RadioGroup
            v-model="myValue"
            style="margin-right:-100px;"
            @on-change="emitValue"
          >
            <Radio
              v-for="(item, key) in otherParams.items"
              :true-value="key"
              :key="key"
              :label="key"
              class="tw-ellipsis"
            >
              <span style="font-size:13px;padding-top:1px;">{{ item }}</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        </Col>
      </Row>
    </div>
    <div v-else>
      <dl
        v-if="value"
        class="uk-description-list"
      >
        <dt>{{ label }}</dt>
        <dd>
          {{ displayValue }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { strings, numbers, booleans, objects } from '@/mixins/props/defaults'

export default {
  mixins: [
    strings('label', 'value'),
    numbers('extraId'),
    booleans('isEditor'),
    objects('otherParams')
  ],
  data () {
    return {
      myValue: null
    }
  },
  computed: {
    displayValue () {
      if (this.value) {
        return this.otherParams.items[this.value]
      }
    }
  },
  mounted () {
    this.myValue = this.value || 0
  },
  methods: {
    emitValue () {
      const payload = {
        id: this.extraId,
        value: this.myValue
      }
      this.$emit('value-changed', payload)
    }
  }
}
</script>
